import React from "react";
import { Input } from "@/components/ui/input";
import { Search, Package, Plus, X } from "lucide-react";

export function AddProductModal({
  open,
  catalogSearch,
  setCatalogSearch,
  catalogSearching,
  catalogResults,
  stopProducts,
  extraProducts,
  onClose,
  onAdd,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4"
      onClick={onClose} data-testid="add-product-modal">
      <div className="bg-[#18181b] border border-white/10 rounded-t-2xl sm:rounded-2xl w-full sm:max-w-lg max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <div>
            <h3 className="text-white font-bold text-base">Aggiungi articolo</h3>
            <p className="text-zinc-500 text-xs">Cerca nel catalogo</p>
          </div>
          <button onClick={onClose} className="p-1 rounded text-zinc-400 hover:text-white" data-testid="close-add-modal">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 border-b border-white/10">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400" />
            <Input
              autoFocus
              placeholder="Nome o codice articolo..."
              value={catalogSearch}
              onChange={(e) => setCatalogSearch(e.target.value)}
              className="pl-10 bg-[#09090b] border-white/10 h-9"
              data-testid="catalog-search-input"
            />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-2">
          {catalogSearching && <p className="text-zinc-500 text-xs text-center py-4">Ricerca in corso...</p>}
          {!catalogSearching && catalogSearch.trim().length < 2 && (
            <p className="text-zinc-500 text-xs text-center py-8">Digita almeno 2 caratteri per cercare</p>
          )}
          {!catalogSearching && catalogSearch.trim().length >= 2 && catalogResults.length === 0 && (
            <p className="text-zinc-500 text-xs text-center py-8">Nessun articolo trovato</p>
          )}
          {catalogResults.map(prod => {
            const alreadyIn = stopProducts.some(p => p.cod_articolo === prod.sku) ||
              extraProducts.some(p => p.cod_articolo === prod.sku);
            return (
              <button key={prod.id}
                disabled={alreadyIn}
                onClick={() => { onAdd(prod); onClose(); }}
                data-testid={`catalog-result-${prod.sku}`}
                className={`w-full flex items-center gap-2 p-2 rounded-lg text-left transition-colors ${
                  alreadyIn ? "opacity-40 cursor-not-allowed" : "hover:bg-white/5"
                }`}>
                <div className="w-8 h-8 rounded bg-white/5 flex items-center justify-center shrink-0">
                  {prod.image_url
                    ? <img src={prod.image_url} alt="" className="w-full h-full object-cover rounded" />
                    : <Package className="w-4 h-4 text-zinc-500" />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white text-xs font-medium truncate">{prod.name}</p>
                  <div className="flex items-center gap-2 text-[10px] text-zinc-500">
                    <span className="font-mono">{prod.sku}</span>
                    <span className="font-mono">{prod.price_list?.toFixed(2)}</span>
                    {alreadyIn && <span className="text-amber-400">già in lista</span>}
                  </div>
                </div>
                {!alreadyIn && <Plus className="w-4 h-4 text-blue-400 shrink-0" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
